"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitForm = exports.monoIntegration = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const constants_1 = require("../../constants/constants");
const homeSlice_1 = require("../../features/home/homeSlice");
const theme_1 = __importDefault(require("../../styles/theme"));
const network_1 = __importStar(require("../../utils/network"));
const icon_1 = require("../icon/icon");
exports.monoIntegration = (0, toolkit_1.createAsyncThunk)('profile/mono/integration', async (payload, { getState, rejectWithValue }) => {
    const { auth } = getState();
    return (0, network_1.default)(`${network_1.BASE_URL}/app/api/v2/mono/submit-token/`, { clientBody: payload, method: 'POST', token: auth.token }, { rejectWithValue });
});
// SUBMIT MONO DATA
const submitForm = async (mono_token, dispatch, getNextProvider, logEventWithExtraProperties) => {
    const result = await dispatch((0, exports.monoIntegration)({ mono_token }));
    logEventWithExtraProperties('api_call', {
        name: 'connect_mono',
        status: 'submitted',
        location: 'screen_Mono',
    });
    if ((0, toolkit_1.isFulfilled)(result)) {
        logEventWithExtraProperties('api_call', {
            name: 'connect_mono',
            status: 'success',
            location: 'screen_Mono',
        });
        dispatch((0, homeSlice_1.addMessages)([
            {
                title: '',
                message: constants_1.APP_MESSAGES.BANK_CONNECTED_SUCCESS,
                iconSize: 55,
                buttonText: 'DONE',
                actionButton: () => {
                    dispatch((0, homeSlice_1.showMessage)());
                },
            },
        ]));
        dispatch((0, homeSlice_1.showMessage)());
    }
    else {
        logEventWithExtraProperties('api_call', {
            name: 'connect_mono',
            status: 'fail',
            location: 'screen_Mono',
        });
        const screenMessage = constants_1.APP_MESSAGES.LAST_PROVIDER_FAIL_CONNECT.replace('<<lastProviderName>>', 'MONO');
        dispatch((0, homeSlice_1.addMessages)([
            {
                title: 'Oops',
                message: screenMessage,
                iconType: icon_1.ALERT_ICON,
                iconColor: theme_1.default.colors.COLOR_CRITICAL,
                iconSize: 55,
                buttonText: 'TRY AGAIN',
                actionButton: () => {
                    if (getNextProvider) {
                        getNextProvider(constants_1.BANK_STATEMENT_PROVIDER_MONO);
                    }
                },
            },
        ]));
        dispatch((0, homeSlice_1.showMessage)());
    }
};
exports.submitForm = submitForm;
